<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Matrículas</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Matrículas',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnNew" type="button" color="primary" elevation="0"
                            to="/matriculas/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="student" label="Aluno" v-model="dataList.filter.student"
                                        hide-details outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field dense id="year" label="Ano" v-model="dataList.filter.year"
                                        hide-details outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field dense id="class" label="Turma" v-model="dataList.filter.class"
                                        hide-details outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-select dense id="status" label="Status" v-model="dataList.filter.status"
                                        :items="dataList.statuses" item-text="text" item-value="value"
                                        hide-details outlined clearable></v-select>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Matrículas</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma matrícula foi encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.year`]="{ item }">
                                <span>{{ item.year.year }}</span>
                            </template>

                            <template v-slot:[`item.student`]="{ item }">
                                <span>{{ item.student.name }}</span>
                            </template>

                            <template v-slot:[`item.class`]="{ item }">
                                <span>{{ item.class.name }}</span>
                            </template>

                            <template v-slot:[`item.date`]="{ item }">
                                {{ item.date | defaultDate('DD/MM/YYYY') }}
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip small label :color="statusColor(item.status)" :text-color="item.status === 'active' ? 'white' : undefined">
                                    {{ statusLabel(item.status) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">
                                    <v-icon :disabled="!$check('users/1', ['PATCH'])" @click="viewItem(item)"
                                        size="large" class="me-2">
                                        mdi-pencil-outline
                                    </v-icon>

                                    <v-icon :disabled="!$check('users/1', ['DELETE'])" @click="deleteItem(item)"
                                        size="large" class="me-2">
                                        mdi-delete
                                    </v-icon>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash, { lodash: _ })

export default {
    name: "SchoolYearList",

    data: () => ({
        dataset: {
            data: {}
        },
        dataList: {
            filter: {
                year: "",
            },
            statuses: [
                { text: "Ativa", value: "active" },
                { text: "Transferida", value: "transferred" },
                { text: "Cancelada", value: "cancelled" },
                { text: "Concluída", value: "completed" },
                { text: "Todos", value: "all" },
            ],
            headers: [
                { text: "Aluno", value: "student" },
                { text: "Turma", value: "class" },
                { text: "Ano", value: "year" },
                { text: "Status", value: "status" },
                { text: "Data", value: "date" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'accent'
                case 2:
                    return 'error'
                default:
                    break;
            }
        },

        statusLabel(status) {
            const labels = {
                active: "Ativa",
                transferred: "Transferida",
                cancelled: "Cancelada",
                completed: "Concluída",
            };

            return labels[status] || "-";
        },

        statusColor(status) {
            const colors = {
                active: "primary",
                transferred: "grey lighten-3",
                cancelled: "red lighten-5",
                completed: "green lighten-5",
            };

            return colors[status] || "grey lighten-3";
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.size;

            try {
                const result = await axios.get('/api/v1/school-enrollments', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`matriculas/${item.id}`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir Matrícula',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/v1/school-enrollments/${item.id}`)

                this.$dialog.notify.info("Matrícula excluída com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },
    },
};
</script>
